import { useMemo } from 'react'
import {
    useStatsPerformMatch,
    useStatsPerformMatchesContext,
} from '../contexts/StatsPerformMatchesContext'
import { getContestantObject } from '../utils/statsperform/statsperformUtils'

export const useStatsPerformContestantsData = (statsperformid: string | undefined) => {
    const match = useStatsPerformMatch(statsperformid)
    const { countries } = useStatsPerformMatchesContext()

    const homeContestantObject = useMemo(() => {
        if (!countries || !match?.data?.matchInfo) return undefined
        return getContestantObject(
            match.data.matchInfo.contestant.find((x) => x.position === 'home'),
            countries,
        )
    }, [countries, match?.data?.matchInfo])

    const awayContestantObject = useMemo(() => {
        if (!countries || !match?.data?.matchInfo) return undefined
        return getContestantObject(
            match.data.matchInfo.contestant.find((x) => x.position === 'away'),
            countries,
        )
    }, [countries, match?.data?.matchInfo])

    return { homeContestant: homeContestantObject, awayContestant: awayContestantObject }
}
